var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Send as SendIcon } from '@mui/icons-material';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography, } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { reenviarFolha } from '../fechamento_mensal_service';
export function ModalReenviarFolha(_a) {
    var _this = this;
    var open = _a.open, onClose = _a.onClose, folhaId = _a.folhaId, onSucesso = _a.onSucesso;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _b = useState(false), processando = _b[0], setProcessando = _b[1];
    var _c = useState(''), erro = _c[0], setErro = _c[1];
    var resetarEstado = function () {
        setProcessando(false);
        setErro('');
    };
    var handleCancelar = function () {
        if (processando)
            return;
        resetarEstado();
        onClose();
    };
    var handleReenviar = function () { return __awaiter(_this, void 0, void 0, function () {
        var resultado, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!folhaId)
                        return [2 /*return*/];
                    setErro('');
                    setProcessando(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, reenviarFolha(folhaId)];
                case 2:
                    resultado = _a.sent();
                    if ((resultado === null || resultado === void 0 ? void 0 : resultado.Status) === 'ERRO') {
                        setErro((resultado === null || resultado === void 0 ? void 0 : resultado.Mensagem) || 'Erro ao processar o reenvio. Tente novamente.');
                        setProcessando(false);
                        return [2 /*return*/];
                    }
                    enqueueSnackbar('Folha reenviada à FUNAC com sucesso.', {
                        variant: 'success',
                        anchorOrigin: { vertical: 'top', horizontal: 'right' },
                    });
                    resetarEstado();
                    onSucesso(resultado);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Erro ao reenviar folha:', error_1);
                    setErro('Falha de comunicação com o servidor. Tente novamente.');
                    setProcessando(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Dialog, __assign({ open: open, onClose: undefined, fullWidth: true, maxWidth: "xs", PaperProps: { sx: { borderRadius: 3, overflow: 'hidden' } } }, { children: [_jsx(DialogTitle, __assign({ sx: { pb: 0.5 } }, { children: _jsx(Typography, __assign({ variant: "h6", sx: { fontWeight: 800, color: '#1976d2', fontSize: '1.1rem' } }, { children: "Reenviar Folha" })) })), _jsxs(DialogContent, __assign({ sx: { pt: 2, px: 3 } }, { children: [_jsx(Typography, __assign({ variant: "body2", sx: {
                            color: '#4b5563',
                            fontSize: '0.9rem',
                            lineHeight: 1.6,
                            mb: 1.5,
                        } }, { children: "Confirma o reenvio desta folha \u00E0 FUNAC?" })), _jsx(Typography, __assign({ variant: "caption", sx: {
                            display: 'block',
                            color: '#6b7280',
                            fontSize: '0.78rem',
                            lineHeight: 1.5,
                        } }, { children: "A folha foi previamente assinada e devolvida para corre\u00E7\u00E3o; o reenvio mant\u00E9m a assinatura eletr\u00F4nica original e bloqueia novas edi\u00E7\u00F5es at\u00E9 a pr\u00F3xima an\u00E1lise." })), erro && (_jsx(Typography, __assign({ variant: "caption", sx: {
                            display: 'block',
                            mt: 2,
                            color: '#ef4444',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                        } }, { children: erro })))] })), _jsxs(DialogActions, __assign({ sx: { px: 3, py: 2, borderTop: '1px solid #e5e7eb' } }, { children: [_jsx(Button, __assign({ id: "btn-cancelar-reenvio", variant: "outlined", onClick: handleCancelar, disabled: processando, sx: {
                            fontWeight: 700,
                            color: '#4b5563',
                            borderColor: '#d1d5db',
                            borderRadius: 2,
                            px: 3,
                            backgroundColor: '#ffffff',
                            '&:hover': { backgroundColor: '#f3f4f6', borderColor: '#d1d5db' },
                        } }, { children: "CANCELAR" })), _jsx(Button, __assign({ id: "btn-confirmar-reenvio", variant: "contained", onClick: handleReenviar, disabled: processando, disableElevation: true, startIcon: processando ? (_jsx(CircularProgress, { size: 16, color: "inherit" })) : (_jsx(SendIcon, { sx: { fontSize: 16 } })), sx: {
                            fontWeight: 700,
                            backgroundColor: '#1976d2',
                            color: 'white',
                            borderRadius: 2,
                            px: 3,
                            '&:hover': { backgroundColor: '#1565c0' },
                            '&.Mui-disabled': {
                                backgroundColor: '#93c5fd',
                                color: 'white',
                            },
                        } }, { children: processando ? 'PROCESSANDO...' : 'REENVIAR' }))] }))] })));
}
